/*
 * MG — ATC Drawer (desktop) + Toast (mobile)
 *
 * Desktop (>= 750px): slide-in drawer with recs
 * Mobile  (<  750px): small toast confirmation only
 *
 * Relies solely on the cart:added event fired by product-form.js.
 */
(function () {
  'use strict';

  var isMobile = function () { return window.innerWidth < 750; };

  var fmt = function (cents) {
    return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(cents / 100);
  };

  /* ── Mobile toast ── */
  var toast = document.createElement('div');
  toast.className = 'mg-atc-toast';
  toast.innerHTML =
    '<div class="mg-atc-toast__icon">' +
    '<svg viewBox="0 0 24 24" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>' +
    '</div>' +
    '<span>Added to cart</span>';
  document.body.appendChild(toast);

  var toastTimer = null;
  function showToast() {
    clearTimeout(toastTimer);
    toast.classList.add('is-visible');
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  /* ── Desktop drawer ── */
  var drawer = document.getElementById('mg-atc-drawer');
  var overlay = drawer && drawer.querySelector('.mg-atc-drawer__overlay');
  var closeBtn = drawer && drawer.querySelector('.mg-atc-drawer__close');
  var addedImg = drawer && document.getElementById('mg-atc-drawer-img');
  var addedName = drawer && document.getElementById('mg-atc-drawer-name');
  var addedPrice = drawer && document.getElementById('mg-atc-drawer-price');
  var recsWrap = drawer && document.getElementById('mg-atc-drawer-recs');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function showAdded(item) {
    if (addedImg) {
      addedImg.src = item.image ? item.image.replace(/(\.(\w+))(\?|$)/, '_120x$1$3') : '';
      addedImg.alt = item.product_title || '';
      addedImg.style.display = item.image ? 'block' : 'none';
    }
    if (addedName) addedName.textContent = item.product_title || '';
    if (addedPrice) addedPrice.textContent = fmt(item.final_line_price || item.price);
  }

  function loadRecs(productId, cartProductIds) {
    if (!recsWrap || !productId) return;
    recsWrap.innerHTML = '';
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=8&intent=related')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.products || !data.products.length) return;
        var recs = data.products
          .filter(function (p) {
            return cartProductIds.indexOf(p.id) === -1 &&
              p.variants && p.variants.some(function (v) { return v.available; });
          })
          .slice(0, 4);
        if (!recs.length) return;
        var html = '<div class="mg-atc-drawer__recs-label">You May Also Like</div>';
        html += '<div class="mg-atc-drawer__recs-grid">';
        recs.forEach(function (p) {
          var img = p.featured_image
            ? p.featured_image.replace(/(\.(\w+))(\?|$)/, '_400x$1$3')
            : (p.images && p.images.length ? p.images[0].src.replace(/(\.(\w+))(\?|$)/, '_400x$1$3') : '');
          var v = p.variants[0];
          var price = fmt(v.price);
          var compare = v.compare_at_price && v.compare_at_price > v.price
            ? '<span class="mg-atc-drawer__rec-compare">' + fmt(v.compare_at_price) + '</span>' : '';
          var avail = p.variants.some(function (x) { return x.available; });
          var availVariant = p.variants.find(function (x) { return x.available; });
          html += '<div class="mg-atc-drawer__rec-card">';
          html += '<a href="/products/' + p.handle + '">';
          if (img) html += '<img class="mg-atc-drawer__rec-img" src="' + img + '" alt="' + p.title + '" loading="lazy">';
          html += '</a>';
          html += '<div class="mg-atc-drawer__rec-info">';
          html += '<a href="/products/' + p.handle + '" class="mg-atc-drawer__rec-name">' + p.title + '</a>';
          html += '<div><span class="mg-atc-drawer__rec-price">' + price + '</span>' + compare + '</div>';
          html += '</div>';
          if (avail && availVariant) {
            html += '<button type="button" class="mg-atc-drawer__rec-atc" data-variant-id="' + availVariant.id + '">+ Add</button>';
          } else {
            html += '<span class="mg-atc-drawer__rec-atc mg-atc-drawer__rec-atc--oos">Sold Out</span>';
          }
          html += '</div>';
        });
        html += '</div>';
        recsWrap.innerHTML = html;
      })
      .catch(function () {});
  }

  /* Quick-add from rec cards inside drawer */
  if (recsWrap) {
    recsWrap.addEventListener('click', function (e) {
      var btn = e.target.closest('.mg-atc-drawer__rec-atc');
      if (!btn || btn.classList.contains('mg-atc-drawer__rec-atc--oos')) return;
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
      })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          btn.textContent = '\u2713 Added';
          btn.classList.add('mg-atc-drawer__rec-atc--added');
          fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) {
                el.textContent = cart.item_count;
              });
            });
          setTimeout(function () {
            btn.textContent = '+ Add';
            btn.classList.remove('mg-atc-drawer__rec-atc--added');
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.textContent = 'Error';
          btn.disabled = false;
          setTimeout(function () { btn.textContent = '+ Add'; }, 2000);
        });
    });
  }

  /* ── Google Ads ATC conversion ── */
  function fireAtcConversion(item) {
    if (typeof gtag !== 'function') return;
    gtag('event', 'conversion', {
      'send_to': 'AW-17974859845/Y6IZCKLvs_4bEMWwivtC',
      'value': item ? parseFloat((item.final_line_price || item.price) / 100).toFixed(2) : 1.0,
      'currency': 'AUD'
    });
  }

  function handleCartAdded(item, productId) {
    /* Fire Google Ads ATC conversion on every add-to-cart */
    fireAtcConversion(item);

    if (isMobile()) {
      /* Mobile: just show the small toast */
      showToast();
      /* Still update cart count bubble */
      fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
        })
        .catch(function () {});
      return;
    }

    /* Desktop: full drawer */
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var cartIds = cart.items.map(function (i) { return i.product_id; });
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        showAdded(item);
        loadRecs(productId, cartIds);
        openDrawer();
      })
      .catch(function () {
        showAdded(item);
        openDrawer();
      });
  }

  document.addEventListener('cart:added', function (e) {
    var item = e.detail && e.detail.item ? e.detail.item : null;
    if (!item) return;
    handleCartAdded(item, item.product_id);
  });

})();
